import React from "react";
import Text from "components/atoms/Text";
import { COLOR_SYSTEM } from "components/design/design-system";
import {
  Slider,
  SwitchButton,
  SwitchWrapper,
} from "components/atoms/Switch/style";

export type SwitchSize = "Large" | "Medium" | "Small";
type LabelPosition = "Left" | "Right";

export interface SwitchProps {
  size: SwitchSize;
  isActive: boolean;
  label?: string;
  labelPosition?: LabelPosition;
  className?: string;
  style?: React.CSSProperties;
  onClick: (params?: any) => any;
}

const Switch: React.FC<SwitchProps> = ({
  size,
  isActive,
  label,
  labelPosition = "Right",
  className,
  style,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLLabelElement>) => {
    e.preventDefault();
    onClick();
  };

  return (
    <SwitchWrapper className={className} style={style}>
      {label && labelPosition === "Left" && (
        <Text
          textType={size === "Small" ? "InputMedium" : "InputLarge"}
          color={
            isActive
              ? COLOR_SYSTEM.get("Gray")?.[700]
              : COLOR_SYSTEM.get("Gray")?.[400]
          }
        >
          {label}
        </Text>
      )}
      <SwitchButton size={size} isActive={isActive} onClick={handleClick}>
        <input type="checkbox" />
        <Slider size={size} isActive={isActive} />
      </SwitchButton>
      {label && labelPosition === "Right" && (
        <Text
          textType={size === "Small" ? "InputMedium" : "InputLarge"}
          color={
            isActive
              ? COLOR_SYSTEM.get("Gray")?.[700]
              : COLOR_SYSTEM.get("Gray")?.[400]
          }
        >
          {label}
        </Text>
      )}
    </SwitchWrapper>
  );
};

export default Switch;
